<template>
  <div class="d-flex flex-md-row flex-xxs-column mt-5 align-items-center px-3 line-height-2">
    <p class="order-md-1 order-xxs-2 lead m-0" v-html="$t('UserProfile.Common.CongratulationsMessage', {portal:'بازیلی', product: this.globalResources.productTranslation.Single, products: this.globalResources.productTranslation.Plural,collections: this.globalResources.collection.Plural})" />
    <div class="order-md-2 order-xxs-1">
      <img height="256" src="@/assets/icons/welcome-owl.svg">
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserProfileCongratulationsMessage'
}
</script>
